<h2 mat-dialog-title>Assign User</h2>

<mat-dialog-content>

  <mat-form-field style="width:100%;">
    <mat-label>Select User</mat-label>

    <mat-select [(ngModel)]="selectedUserId">

      @for (u of data.users; track u.id) {
      <mat-option [value]="u.id">
        {{ u.firstName }} {{ u.lastName }}
      </mat-option>
      }

    </mat-select>

  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions align="end">

  <button mat-button (click)="close()">Cancel</button>

  <button mat-raised-button color="primary" (click)="confirm()" [disabled]="!selectedUserId">

    Assign
  </button>

</mat-dialog-actions>